const styles = theme => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    margin: "50px auto"
  },
  left: {
    width: "calc(50% - 15px)",
    backgroundColor: "#333",
    padding: 50,
    color: "white",

    "& h1": {
      fontWeight: "600",
      textTransform: "uppercase"
    },

    "& h5": {
      color: "#ccc"
    }
  },
  progressBox: {
    marginTop: 30
  },
  progressName: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",

    "& h5": {
      color: theme.colors.primary,
      fontWeight: "600",
      marginBottom: 5,
      textTransform: "uppercase"
    }
  },
  progressBar: {
    position: "relative"
  },
  progressFull: {
    width: "100%",
    height: 16,
    backgroundColor: "white",
    borderRadius: 10
  },
  progressCurrent: {
    height: 16,
    backgroundColor: theme.colors.primary,
    borderRadius: 10,
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1
  },
  right: {
    width: "calc(50% - 15px)"
  },
  procedureZone: {
    display: "flex",
    flexWrap: "wrap",
    margin: -15
  },
  box: {
    width: "calc(100% / 2 - 30px)",
    margin: 15,
    position: "relative",
    textAlign: "center",

    "& h3": {
      fontWeight: "600",
      marginBottom: 10
    },

    "& h5": {
      color: "#555"
    },

    "& h2": {
      position: "absolute",
      bottom: -30,
      right: 0,
      color: "#e1e1e1",
      fontSize: 80,
      opacity: 0.3,
      fontWeight: "600"
    }
  },
  procedureImg: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    backgroundColor: "#e1e1e1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
    marginBottom: 10,
    transition: ".3s",

    "&:hover": {
      backgroundColor: "#ccc"
    },

    "& img": {
      width: 40
    },
  },

  [theme.breakpoints.down('xs')]: {
    container: {
      display: 'block',
    },
    left: {
      width: "100%"
    },
    right: {
      marginTop: "10px",
      width: "100%",
    }
  },
});

export default styles;
